import {ApplicationStyles} from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	inputSelect: {
		flex: 1,
		width: '100%',
		marginBottom: 8
	}
}));

export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
    inputSelect:{
    	flex: 1,
    	width: '100%',
        paddingBottom: 8,
	},
	div:{
    	width: '100%',
    },
	inputSelectSecond:{
    	width: '100%',
    	paddingRight: 8,
        paddingBottom: 8,
    }
})

